import { Reducer } from "redux";
import { isRoutingEvent } from "../routing_events";
import { REVIZTO_ACCESS_TOKEN_DIALOG_SHOWN, ReviztoAccessTokenDialogShownEvent } from "../../events/viewer/revizto_access_token_dialog_shown";
import { REVIZTO_ACCESS_TOKEN_DIALOG_DISMISSED, ReviztoAccessTokenDialogDismissedEvent } from "../../events/viewer/revizto_access_token_dialog_dismissed";
import PlannedBuildingElement from "../../models/domain/planned_building_element";


export type ReviztoAccessTokenDialogStore = {
  open: boolean
  selectedElements?: PlannedBuildingElement[]
  globalId?: string
}

type Events =
  | ReviztoAccessTokenDialogShownEvent
  | ReviztoAccessTokenDialogDismissedEvent

const reduceReviztoAccessTokenDialog: Reducer<ReviztoAccessTokenDialogStore, Events> = (reviztoAccessTokenDialog = { open: false }, event) => {
  if (isRoutingEvent(event)) {
    return { open: false };
  }
  switch (event.type) {
    case REVIZTO_ACCESS_TOKEN_DIALOG_SHOWN: {
      return {
        ...reviztoAccessTokenDialog,
        open: true,
        globalId: event.payload.globalId,
        selectedElements: event.payload.selectedElements
      };
    }
    case REVIZTO_ACCESS_TOKEN_DIALOG_DISMISSED: {
      return {
        ...reviztoAccessTokenDialog,
        open: false,
      };
    }

    default: {
      return reviztoAccessTokenDialog;
    }
  }
};

export default reduceReviztoAccessTokenDialog;
